import * as PIXI from 'pixi.js'
import config from 'config'
import { getTextureList, getReplacedTextures, replaceBaseTexture } from '../../utils'
import TextureSelector from './TextureSelector'

class Texture extends React.Component {
  state = {}
  componentWillMount() {
    this.updateTextureList()
  }

  onReaderLoad = (event) => {
    const obj = JSON.parse(event.target.result)

    Object.keys(obj).forEach(textureName => {
      const img = new Image()
      img.addEventListener('load', () => {
        replaceBaseTexture(textureName, new PIXI.BaseTexture(img))
        this.updateTextureList()
      })
      img.src = obj[textureName]
    })

    setTimeout(() => this.forceUpdate(), 500)
  }

  updateTextureList = () => {
    const assets = getTextureList()
    this.setState({ textureEntries: Object.keys(assets) })
  }

  download = () => {
    const ret = {}
    const textures = getReplacedTextures()

    Object.keys(textures).forEach(key => {
      const texture = textures[key]
      if (texture.resource.source.nodeName.toLowerCase() !== 'img') {
        return
      }

      ret[key] = texture.resource.source.src
    })

    const blob = new Blob([ JSON.stringify(ret) ], { type: 'application/json' }) // pass a useful mime type here
    const url = URL.createObjectURL(blob)

    const { downloadElement } = this
    downloadElement.setAttribute('href', url)
    downloadElement.setAttribute('download', `${config.GAME_CONFIG.GAME_ID}-textures.json`)
    downloadElement.click()
  }

  upload = (e) => {
    const reader = new FileReader()
    reader.onload = this.onReaderLoad
    reader.readAsText(e.target.files[0])
  }

  render() {
    const { textureEntries = [] } = this.state

    return (
      <div>
        <a ref={e => this.downloadElement = e} style={{ display: 'none' }} />
        <div style={{ textAlign: 'center', paddingBottom: '30px' }}>
          <input style={{ marginRight: '15px' }} type="button" value="Download" onClick={this.download} />
          <input type="file" id="selectFiles" onChange={this.upload} />
        </div>
        <div className="devConsolePage">
          { textureEntries.map((key) =>
            (<TextureSelector
              textureName={key}
              onReplacement={this.updateTextureList}
              key={key}
            />))}
        </div>
      </div>
    )
  }
}

Texture.title = 'Texture'

export default Texture
